import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from '@scentregroup/ui'
import classNames from 'classnames'
import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.scss'

const dropdownOptions = [
  { value: 'most_recent_sort', label: 'Sort by: Recent' },
  { value: 'price_low_high_sort', label: 'Sort by: Price low to high' },
  { value: 'price_high_low_sort', label: 'Sort by: Price high to low' },
  { value: 'store_name_sort', label: 'Sort by: Store name' },
  { value: 'product_name_sort', label: 'Sort by: Product name' },
]

class SortDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sort: props.sort,
    }
  }

  updateSort = event => {
    const { buildUrl, history } = this.props
    this.setState({ sort: event.target.value })

    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PRODUCTS_SORT_SELECTED,
      eventCategory: 'Sort By',
      eventAction: 'Sort',
      eventLabel: event.target.value,
    })

    history.push(buildUrl({ sort: event.target.value }))
  }

  render() {
    return (
      <div className={classNames(this.props.className)}>
        <Dropdown
          options={dropdownOptions}
          value={this.state.sort}
          classNames={{ wrapper: style.wrapper, field: style.dropdownField }}
          ariaLabel={'sort products'}
          onChange={this.updateSort}
        />
      </div>
    )
  }
}

SortDropdown.propTypes = {
  sort: PropTypes.string,
  history: PropTypes.object,
  buildUrl: PropTypes.func.isRequired,
  className: PropTypes.string,
}

SortDropdown.defaultProps = {
  sort: 'most_recent_sort',
}

export default SortDropdown
